import { GET_ITEM_DELIVERY_SUMMARY } from '../actionTypes/OrderActionTypes';

export default function ItemDeliverySummaryReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ITEM_DELIVERY_SUMMARY:
            return action.payload;
        default:
            return state;
    }
}
